const products = {
  "Ideal Gift 7-Inch Android Tablet for Kids and Adults": 3500,
  "High-Performance 10.1-Inch Android Tablet with 12GB RAM & Large Storage": 6000,
  "012BAC Studio Monitor Speaker": 11000,
  "1.75-inch Lady Smart Watch – Health Monitoring, Bluetooth Calling, Waterproof, Blood Oxygen & Multi-Sport Modes": 2500,
  "1.7m Professional Auto Face Tracking Selfie Stick Tripod Stand Holder with Tracker for Phone/Camera": 5000,
  "1.95-inch Touchscreen, Heart Rate, Blood Pressure & Sleep Monitoring, IP67 Waterproof, Multi-Function Fitness Tracker": 1800,
  "10 Inch Touchscreen Tablet with Android OS": 4500,
  "10-Inch Android Tablet with 12GB RAM, 128GB Storage, 5G Wi-Fi, Rockchip Processor, Includes Pen and Keyboard": 10000,
  "10-Inch Android Tablet with 4G Calling Function": 4000,
  "10-Inch Fanless Touch Android Monitor with HD Ports – Metal Case, Wall Mount for Industrial Use": 70000,
  "10.1-Inch Adult Tablet PC with Android 8.1, Multi-Language Support, 2GB RAM, 32GB Storage, Educational Learning Games": 9000,
  "10000mAh Fast Charging Power Bank with Wireless Charging – 22.5W PD Quick Charger": 2500,
  "1080P HD Mini Child Kids Camera Toy with Instant Print and Games": 1200,
  "1200mAh Portable Solar Phone Charger": 1000,
  "13-16 Inch Laptop Sleeve Case – Waterproof Oxford Carrying Bag": 1500,
  "13-Inch Tablet with 2K Resolution and High Performance": 20000,
  "15W Fast Charging Strong Magnet Wireless Phone Charger": 3000,
  "2-in-1 Smartwatch with TWS Earphones – Health Monitoring, Waterproof with NFC": 2000,
  "2025 New Pandora 50000 in 1 3D Game Box Retro Arcade HD Video Game Console for Home Arcade, Plug and Play": 13500,
  "220V 1200W/2200W/3500W DC/AC Mobile Power Station with QC PD Output and Solar Charging Capability": 44000,
  "3-Port USB 2.0 Hub – Mini High-Speed Rotating Splitter Adapter for Laptop": 692,
  "3.1A Car Charger QC3.0 Dual USB with LED Display for Fast Charging – 12-24V Cigarette Lighter Adapter": 500,
  "3-Port USB Wall Charger with QC 3.0 Fast Charging – EU/US Plug Mobile Phone Charger": 800,
  "3.1A Fast Car Charger USB Type-C for Mobile Phones and Tablets – Quick Charging Auto Adapter": 1300,
  "300M Wireless WiFi Repeater Signal Amplifier and Expander Router": 1500,
  "4-Port USB 3.0 Hub with High-Speed Type-C Splitter, USB 3.0 and 2.0 Ports": 800,
  "4K Digital Camera with Autofocus & 48MP Sensor": 11000,
  "4K Game Box Video Game Console with Wireless Controller and HDMI Output": 6700,
  "4K HD Digital Camera with 64MP Resolution and 18X Digital Zoom": 10000,
  "5GHz Wireless WiFi Repeater 1200Mbps Router": 1100,
  "Adhesive Elastic Lycra Mouse Pouch – Removable Laptop & Tablet Back Holder": 500,
  "Air Vent Car Holder for Magsafe Mount Stand Bracket Cellphone Phone Holder": 1000,
  "Commercial Drone with Lidar Sensor, Thermal Camera, and RTK Technology": 95000,
  "Ergonomic Memory Foam Gaming Mouse Pad with Wrist Rest": 400,
  "Easy Install Privacy Screen Protector with Dust Removal Strip": 1000,
  "Foldable Wireless Mouse with 2.4GHz Optical USB, Ergonomic Design, and Matte Surface": 600,
  "Home Gaming Standard Computer Mouse – 3D USB Wired Optical Mouse": 300,
  "LC Wireless Network Card Wi-Fi Receiver 150Mbps Network Card Wi-Fi Transmitter Set-Top Box Receiver Desktop MTK7601": 500,
  "New Fabric Loud Sound Box Subwoofer – Rich Bass Waterproof Mini Portable Wireless Speaker": 800,
  "Outdoor Waterproof 10/100Mbps 1-Input 1-Output PoE Extender for Network Devices": 1200,
  "Portable USB Mini Wired Desktop/Laptop Speakers – 2.0 Channel Stereo Sound": 600,
  "Portable Wireless Desktop Speaker for Home & Outdoor Use": 6000,
  "Premium Bluetooth Speaker – Outdoor & Indoor Wireless Sound System": 2000,
  "Professional GPS Drone with 4K Camera, 5G WiFi, FPV, and Long Range": 19000,
  "Professional GPS Drone with 8K Dual Camera, Brushless Motor, and 25-Minute Flight Time": 9500,
  "Restaurant Ordering Kiosk Tablet Touch Screen NFC Tablet PC Android POS L Shape Tablets": 10000,
  "Retro Handheld Game Console with 3.5-Inch IPS Screen and 6000+ Games": 5000,
  "RGB LED Custom Gaming Wireless Rechargeable Mouse with Dual-Mode and Silent Operation": 400,
  "RGB LED Gaming Mouse Pad – Large, Durable Rubber Surface": 1200,
  "Single Board Computer – RK3588 Module with Accessories": 700,
  "Smart Watch with GPS, AMOLED Display, SIM Card Slot, and Wi-Fi Connectivity": 5500,
  "Soft Black Gaming Mouse Pad – Smooth Surface, Natural Rubber Base": 300,
  "Stainless Steel Outdoor 10.1-Inch Android Tablet PC – Industrial Waterproof IP65": 45000,
  "Ultra HD 4K Video Camera Camcorder with 3-Inch Screen and 18X Digital Zoom": 15000,
  "Ultra WiFi Sports Smartwatch with 2-in-1 Earbuds": 3500,
  "USB 3.0 OTG Card Reader – Multi-interface for Mobile Phones & MacBook": 600,
  "Waterproof Portable Gaming Keyboard with Mechanical Feel and Colorful Backlit Keys": 1800,
  "Wired & Wireless Gaming Headset with RGB Lighting": 8000,
  "Wireless Foldable Gaming Headset with LED Lights": 3500,
  "X6 Portable Retro Game Console with TV Out Support and 10,000 Built-in Games": 4000,
  "Woman Smartwatch – Full Screen, Bluetooth Call": 1100,
};

const orgDetails = {
  orgName: "Wagg Electronics India Pvt Ltd",
  orgAddress:
    "417, C-1/3, Laxmi Tower, Naniwala Bagh, Azadpur, New Delhi, North Delhi, Delhi 110033",
  gstNumber: "07AACCW3878M2ZM",
  phoneNumber: "+91 8929548205",
};

const shortName = "WE";

const wagg = { products, orgDetails, shortName };
export default wagg;
